module.exports = __webpack_public_path__ + "static/media/c.037597e9.m4a";